import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { ConfigurationContext } from '../context/ConfigurationContext'
import { UserContext } from '../context/UserContext'
import Container from '../components/Container'
import QuestionButton from '../components/QuestionButton/QuestionButton'
import QuestionRadio from '../components/QuestionRadio/QuestionRadio'
import QuestionSlider from '../components/QuestionSlider/QuestionSlider'
import QuestionImage from '../components/QuestionImage/QuestionImage'
import QuestionCheckboxMulti from '../components/QuestionCheckboxMulti/QuestionCheckboxMulti'
import QuestionRadioMulti from '../components/QuestionRadioMulti/QuestionRadioMulti'
import Wysiwyg from '../components/Wysiwyg/Wysiwyg'

import { v4 as uuidv4 } from 'uuid';

const ConfigView = () => {
  const [reset, setReset] = useState(false);
  const [state, setState] = useState({ pageIndex: null, redirect: false, toggleNext: false, togglePrev: false });
  const { configurations, setConfigurations } = useContext(ConfigurationContext);
  const { 
    type,
    setType,
    getAnswers,
    setAnswer,
    setAnswers,
    configurationId,
    setConfigurationId 
  } = useContext(UserContext);

  state.pageIndex = state.pageIndex === null ? 0 : state.pageIndex;

  if(reset === true) {
    setType(null)
    setConfigurationId(null);
    setAnswers([]);

    return <Redirect to='/start'/>;
  }

  const handleReset = () => {
    setReset(true);
  }

  if(!configurations || !configurationId) return <Redirect to='/'/>;
  
  const currentProduct = configurations.items.find( item => item.id === parseInt(configurationId));
  const currentOption = currentProduct.fields.find( (item) => {
    return state.pageIndex === item.id
  });

  const lastPosition = currentProduct.fields.length-1;

  const currentAnswer = getAnswers().find(i => i.id === state.pageIndex);

  if(state.redirect === true) return <Redirect to='/summary'/>;

  const handleAnswerCallback = (answer) => {
    if( getAnswers().length !== currentProduct.fields.length - 1 ) {
      state.pageIndex++;
    }

    setAnswer(currentOption.id, answer);
  }

  const handleSubmit = () => {
    setState( { ...state, redirect: true } );
  }

  const handleNavCallback = (answer, direction) => {
    if(answer) {
      setAnswer(currentOption.id, answer);
    }

    if(direction === 'next') {
      setState({ ...state, toggleNext: true });
    } else if(direction === 'prev') {
      setState({ ...state, togglePrev: true });
    }
  }

  if( state.toggleNext === true ) {
    const optionHasAnswer = getAnswers().find( i => i.id === currentOption.id );
    state.toggleNext = false;

    if(optionHasAnswer) {
      setState({ pageIndex: state.pageIndex+1 });
    }
  }

  if( state.togglePrev === true ) {
    state.togglePrev = false;

    setState({ pageIndex: state.pageIndex-1 });
  }

  return (
    <Container>
      <div class="text-center">
        <h1 class="text-3xl sm:text-5xl font-bold mb-10">{currentOption.heading}</h1>

        <p class="text-base sm:text-xl mb-10">{currentOption.text}</p>
      </div>

      {currentOption.type === 'slider' ? 
        <QuestionSlider options={currentOption} callback={handleAnswerCallback} currentAnswer={currentAnswer} navCallback={handleNavCallback} lastPosition={lastPosition} currentIndex={state.pageIndex} />
      : currentOption.type === 'button' ? 
        <QuestionButton options={currentOption.options} callback={handleAnswerCallback} currentAnswer={currentAnswer} navCallback={handleNavCallback} lastPosition={lastPosition} currentIndex={state.pageIndex} />
      : currentOption.type === 'radio' ? 
        <QuestionRadio options={currentOption.options} callback={handleAnswerCallback} currentAnswer={currentAnswer} navCallback={handleNavCallback} lastPosition={lastPosition} currentIndex={state.pageIndex} />
      : currentOption.type === 'image' ? 
        <QuestionImage options={currentOption.options} callback={handleAnswerCallback} currentAnswer={currentAnswer} navCallback={handleNavCallback} lastPosition={lastPosition} currentIndex={state.pageIndex} />
      : currentOption.type === 'checkboxMulti' ?
        <QuestionCheckboxMulti options={currentOption} callback={handleAnswerCallback} navCallback={handleNavCallback} lastPosition={lastPosition} currentIndex={state.pageIndex} />
      : currentOption.type === 'radioMulti' ?
        <QuestionRadioMulti options={currentOption} callback={handleAnswerCallback} navCallback={handleNavCallback} lastPosition={lastPosition} currentIndex={state.pageIndex} />
      : getAnswers().length === currentProduct.fields.length - 1 ?
        <Wysiwyg callback={handleAnswerCallback} currentAnswer={currentAnswer} navCallback={handleNavCallback} lastPosition={lastPosition} currentIndex={state.pageIndex} />
      : currentOption.type === 'textblock' ?
        <Wysiwyg callback={handleAnswerCallback} currentAnswer={currentAnswer} navCallback={handleNavCallback} lastPosition={lastPosition} currentIndex={state.pageIndex} />
      : null }

      <div className={'text-center mt-4'}>
        <button className={'text-medium no-underline text-black inline-block px-1 py-1'} onClick={handleReset}>
          Återställ alla val
        </button>
      </div>

      {lastPosition === state.pageIndex ? 
        <div class="flex justify-end mt-6">
          <input
            type="button"
            value="Granska!"
            className="px-8 py-3 bg-green text-2xl text-white font-medium rounded-tl-3xl rounded-br-3xl font-bold cursor-pointer"
            onClick={handleSubmit}
          />
        </div>
      : null }

    </Container>
  );
};

export default ConfigView;
